import http from '../../../utils/fetch';
export default {
    showPage(query){
        return http({
            url: '/api/swyl/v1/demo/bscForecastFore/showPage',
            method: 'post',
            params: query
        });
    },
    page(query) {
        return http({
            url: '/api/swyl/v1/demo/bscForecastFore/selectPage',
            method: 'post',
            params: query
        });
    },
    saveTo(obj) {
        return http.post('/api/swyl/v1/demo/bscForecastFore/insert',obj);
    },
    deleteId(id){
        return http.post('/api/swyl/v1/demo/bscForecastFore/deleteById?id='+id);
    }
}